import { render, staticRenderFns } from "./BannerSection.vue?vue&type=template&id=30507b2c&"
import script from "./BannerSection.vue?vue&type=script&lang=js&"
export * from "./BannerSection.vue?vue&type=script&lang=js&"
import style0 from "./BannerSection.vue?vue&type=style&index=0&id=30507b2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports